/*
  Please follow [convention](https://segment.com/academy/collecting-data/naming-conventions-for-clean-data)
*/
export enum TrackingEventName {
  FunnelQuestionAnswered = 'Funnel Question Answered',
  HighPriorityCandidateRegistered = 'High Priority Candidate Registered',
  JobBoardFiltersUpdated = 'Job Board Filters Updated',
  JobPositionCardViewed = 'Job Position Card Viewed',
  JobPositionCardClicked = 'Job Position Card Clicked',
  JobPositionViewed = 'Job Position Viewed',
  ProfileSaved = 'Profile Saved',
  NotificationToggle = 'Notification Toggle',
  ModelPushInviteOpen = 'model_push_invite_open',
  RegularPushInviteOpen = 'regular_push_invite_open',
  TrustpilotWidgetViewed = 'trustpilot_widget_viewed',
  CompletionStepViewed = 'completion_step_viewed',
  // Suggestions Modal
  SuggestionsModalInteracted = 'suggestions_modal_interacted',
  SuggestionsModalDismissed = 'suggestions_modal_dismissed',
  // JDP A/B Test
  JdpSectionViewed = 'JDP Section Viewed',
  // Employment Type Nudge A/B Test
  EmploymentTypeNudgeShown = 'employment_type_nudge_shown',
  EmploymentTypeNudgeCtaClicked = 'employment_type_nudge_cta_clicked',
  EmploymentTypeSelectionChanged = 'employment_type_selection_changed',
  RecommendedForYouSectionViewed = 'recommended_for_you_section_viewed',
  // Super quick sign-up A/B test
  QuickSignupCtaViewed = 'quick_signup_cta_viewed',
  QuickSignupCtaClicked = 'quick_signup_cta_clicked',
  // End-of-funnel potential jobs widget
  EndOfFunnelJobsShown = 'end_of_funnel_jobs_shown',
  EndOfFunnelJobsSkipped = 'end_of_funnel_jobs_skipped',
}
